import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import numeral from 'numeral'

let Doughnut

function StatsDoughnut({
  value = 0, maxValue = 0, displayValue, title, format = '0', barColor, barBgColor,
}) {
  const [isLoaded, setIsLoaded] = useState()

  useEffect(() => {
    import('react-chartjs-2').then(module => {
      Doughnut = module.Doughnut
      setIsLoaded(true)
    })
  }, [])

  if (!isLoaded) return null

  const chartConfiguration = {
    data: {
      datasets: [{
        data: [value, (maxValue - value)],
        backgroundColor: [
          barColor,
          barBgColor,
        ],
        hoverBackgroundColor: [
          barColor,
          barBgColor,
        ],
      }],
      labels: [
        'Red models',
        'Total models',
      ],
    },
    options: {
      cutoutPercentage: 85,
      maintainAspectRatio: false,
      legend: {
        display: false,
      },
      title: {
        display: false,
      },
      animation: {
        animateScale: false,
        animateRotate: true,
      },
      elements: {
        arc: {
          borderWidth: 0,
        },
      },
      tooltips: {
        enabled: false,
      },
    },
  }
  return (
    <div className="stats-doughnut">
      <Doughnut redraw data={chartConfiguration.data} options={chartConfiguration.options} height={120} width={120} />
      <div className="stats-doughnut__info">
        <div className="stats-doughnut__value">{numeral(displayValue).format(format)}</div>
        <div className="stats-doughnut__title">{title}</div>
      </div>
    </div>
  )
}

StatsDoughnut.propTypes = {
  value: PropTypes.number,
  maxValue: PropTypes.number,
  displayValue: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  barColor: PropTypes.string.isRequired,
  barBgColor: PropTypes.string.isRequired,
  format: PropTypes.string,
}

export default StatsDoughnut
